var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Button, Flex, Icon, Link, Modal, Text, Title } from '@homeexchange/design';
import React from 'react';
import i18n from '../../../i18n';
import { Trans } from 'react-i18next';
import moment from 'moment';
import styles from './savedSearchModal.module.scss';
var DATE_RANGE_SINGLE = 1;
var DATE_RANGE_MULTIPLE_THRESHOLD = 4;
var durationKindLabels = {
    'week-end': i18n.t('common:duration.weekend'),
    'one-week': i18n.t('common:duration.week'),
    'two-weeks': i18n.t('common:duration.week_plural', { count: 2 }),
    'one-month': i18n.t('common:duration.month')
};
var formatFlexibleDurationText = function (duration, formattedDates) {
    var durationLabel = durationKindLabels[duration] || duration;
    return "".concat(durationLabel).concat(formattedDates);
};
var groupDatesByYear = function (dates) {
    var sortedDates = __spreadArray([], dates, true).sort(function (a, b) { return a.getTime() - b.getTime(); });
    var monthsByYear = {};
    sortedDates.forEach(function (date) {
        var year = moment(date).format('YYYY');
        if (!monthsByYear[year]) {
            monthsByYear[year] = [];
        }
        monthsByYear[year].push(date);
    });
    var formattedGroups = Object.entries(monthsByYear).map(function (_a) {
        var year = _a[0], datesInYear = _a[1];
        var monthNames = datesInYear
            .map(function (date) { return moment(date).format('MMMM'); })
            .join(', ')
            .replace(/, ([^,]*)$/, i18n.t('search:date_ranges_replace'));
        return "".concat(monthNames, " ").concat(year);
    });
    return formattedGroups.join(', ');
};
var formatFlexibleSearchDuration = function (dateRanges, duration) {
    if (!duration)
        return '';
    if (dateRanges.length > DATE_RANGE_SINGLE) {
        var dates = dateRanges.map(function (range) { return new Date(range.from); });
        var formattedDate = groupDatesByYear(dates);
        return formatFlexibleDurationText(duration, i18n.t('search:date_ranges_in', { in: formattedDate }));
    }
    else if (dateRanges.length === DATE_RANGE_SINGLE) {
        var monthYearFormatted = moment(dateRanges[0].from).format('MMMM YYYY');
        return formatFlexibleDurationText(duration, i18n.t('search:date_ranges_in', { in: monthYearFormatted }));
    }
    return '';
};
export var SavedSearchModal = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var isOpen = props.isOpen, onClose = props.onClose, createdAlert = props.createdAlert;
    if (!createdAlert) {
        return null;
    }
    var searchCriteria = createdAlert.searchCriteria || ((_a = createdAlert.attributes) === null || _a === void 0 ? void 0 : _a.searchCriteria) || {};
    var displayInfo = createdAlert.displayInformation || ((_b = createdAlert.attributes) === null || _b === void 0 ? void 0 : _b.displayInformation) || {};
    var dateRange = ((_c = searchCriteria.calendar) === null || _c === void 0 ? void 0 : _c.dateRanges) || [];
    return (React.createElement(Modal, { isOpen: isOpen, isClosable: true, onClose: onClose, areDividersVisible: false, onConfirmAction: onClose, confirmActionText: i18n.t('global:global.cta.understood') },
        React.createElement(Flex, { direction: "column", gap: "0", alignItems: "center", justifyContent: "center", isFullWidth: true },
            React.createElement(Icon, { name: "verification-check-regular", color: "success", size: "7xl" })),
        React.createElement(Flex, { direction: "column", gap: "4" },
            React.createElement(Title, { level: 3 }, i18n.t('user:modal_travelWishlist_confirmationFromSearch_title')),
            React.createElement(Trans, { i18n: i18n, i18nKey: "user:modal_travelWishlist_confirmationFromSearch_body", components: {
                    u: (React.createElement(Link, { href: i18n.t('url:saved_search') },
                        React.createElement(React.Fragment, null)))
                } }),
            React.createElement(Box, { isFullWidth: true, size: "small" },
                React.createElement("div", { className: styles['flex-container'] },
                    React.createElement(Flex, { direction: "column", gap: "2" },
                        React.createElement(Text, { isBold: true }, displayInfo.title || createdAlert.place),
                        React.createElement(Flex, { direction: "row", alignItems: "center", gap: "2", flexWrap: "nowrap" },
                            React.createElement(Icon, { name: "calendar", size: "large" }),
                            React.createElement(Text, { size: "sm", className: styles['text-color-modal'] },
                                dateRange.length > 0 &&
                                    ((_e = (_d = searchCriteria.calendar) === null || _d === void 0 ? void 0 : _d.flexibleSearch) === null || _e === void 0 ? void 0 : _e.duration) && (React.createElement("div", { className: "saved-search-item-date-range" }, formatFlexibleSearchDuration(dateRange, searchCriteria.calendar.flexibleSearch.duration))),
                                dateRange.length > 0 &&
                                    !((_g = (_f = searchCriteria.calendar) === null || _f === void 0 ? void 0 : _f.flexibleSearch) === null || _g === void 0 ? void 0 : _g.duration) &&
                                    dateRange.map(function (range) {
                                        var _a;
                                        return (React.createElement("div", { key: range.from, className: "saved-search-item-date-range" },
                                            moment(range.from).format(moment.localeData().longDateFormat('L')),
                                            ' - ',
                                            moment(range.to).format(moment.localeData().longDateFormat('L')),
                                            ((_a = searchCriteria.calendar.flexibleSearch) === null || _a === void 0 ? void 0 : _a.daysFlexibility) &&
                                                " (".concat(i18n.t('search:flexible-dates-day', {
                                                    number: searchCriteria.calendar.flexibleSearch
                                                        .daysFlexibility
                                                }), ")")));
                                    }),
                                dateRange.length === 0 && (React.createElement(Text, { size: "sm", className: styles['text-color-modal'] }, i18n.t('search:modal.prefDestinations.confirmationFromSearch.noDates'))))),
                        React.createElement(Flex, { direction: "row", alignItems: "center", gap: "2", flexWrap: "nowrap" },
                            React.createElement(Icon, { name: "folk", size: "large" }),
                            React.createElement(Text, { size: "sm", className: styles['text-color-modal'] },
                                React.createElement(React.Fragment, null, ((_h = searchCriteria.guestCriteria) === null || _h === void 0 ? void 0 : _h.guests)
                                    ? (function () {
                                        var guests = searchCriteria.guestCriteria.guests;
                                        var guestTypes = [];
                                        if (guests.adults > 0) {
                                            guestTypes.push("".concat(guests.adults, " ").concat(guests.adults > 1
                                                ? i18n.t('user:traveler.type_adult_plural')
                                                : i18n.t('user:traveler.type_adult')));
                                        }
                                        if (guests.children > 0) {
                                            guestTypes.push("".concat(guests.children, " ").concat(guests.children > 1
                                                ? i18n.t('user:traveler.type_child_plural')
                                                : i18n.t('user:traveler.type_child')));
                                        }
                                        if (guests.babies > 0) {
                                            guestTypes.push("".concat(guests.babies, " ").concat(guests.babies > 1
                                                ? i18n.t('user:traveler.type_baby_plural')
                                                : i18n.t('user:traveler.type_baby')));
                                        }
                                        return guestTypes.length > 0 ? (React.createElement(Text, { size: "sm" }, guestTypes.join(', '))) : (React.createElement(Text, { size: "sm", color: "secondary" }, i18n.t('user:page_travelWishlist_edit_guests_helper')));
                                    })()
                                    : i18n.t('search:modal.prefDestinations.confirmationFromSearch.noGuests'))))),
                    React.createElement(Button, { href: i18n.t('url:saved_search') + '/' + createdAlert.id, color: "tertiary", className: styles['button-modal'] }, i18n.t('commum:edit')))))));
};
